// extracted by mini-css-extract-plugin
module.exports = {"actions":"confirm-dialog_actions__0p9pt"};